import type { SupportTranslations } from './types'

export const arTranslations: SupportTranslations = {
  title: 'تذاكر الدعم',
  subtitle: 'إدارة طلبات الدعم للعملاء والداخلية',
  newTicket: 'تذكرة جديدة',
  getHelp: 'احصل على المساعدة',
  submitTicket: 'إرسال تذكرة',
  submit: 'إرسال التذكرة',

  statusOpen: 'مفتوحة',
  statusInProgress: 'قيد التنفيذ',
  statusWaiting: 'بانتظار المبلّغ',
  statusResolved: 'تم الحل',
  statusClosed: 'مغلقة',

  priorityLow: 'منخفضة',
  priorityMedium: 'متوسطة',
  priorityHigh: 'عالية',
  priorityUrgent: 'عاجلة',

  channelCustomer: 'العملاء',
  channelInternal: 'داخلي',
  allChannels: 'جميع القنوات',
  filterChannel: 'القناة',

  categoryOrder: 'مشكلة في الطلب',
  categoryDelivery: 'مشكلة في التوصيل',
  categoryPayment: 'مشكلة في الدفع',
  categoryAccount: 'مشكلة في الحساب',
  categoryBug: 'خلل في المنصة',
  categoryFeature: 'طلب ميزة',
  categoryGeneral: 'عام',
  categoryOther: 'أخرى',

  statsOpen: 'مفتوحة',
  statsInProgress: 'قيد التنفيذ',
  statsResolved: 'تم الحل',
  statsTotal: 'الإجمالي',

  colTicket: 'رقم التذكرة',
  colSubject: 'الموضوع',
  colChannel: 'القناة',
  colCategory: 'الفئة',
  colPriority: 'الأولوية',
  colStatus: 'الحالة',
  colCreated: 'تاريخ الإنشاء',

  fieldSubject: 'الموضوع',
  fieldCategory: 'الفئة',
  fieldPriority: 'الأولوية',
  fieldDescription: 'الوصف',
  fieldEmail: 'البريد الإلكتروني',
  fieldPhone: 'رقم الهاتف',
  fieldAttachments: 'الصور',
  subjectPlaceholder: 'ملخص موجز لمشكلتك',
  selectCategory: 'اختر الفئة',
  descriptionPlaceholder: 'صف مشكلتك بالتفصيل...',
  emailPlaceholder: 'email@example.com',
  phonePlaceholder: '+966 5X XXX XXXX',
  attachmentsHint: 'حمّل حتى 5 صور (بحد أقصى 10 ميجابايت لكل صورة)',
  attachmentsRequired: 'يلزم إرفاق صورة واحدة على الأقل',
  removePhoto: 'إزالة الصورة',
  addPhoto: 'اضغط لإضافة صور',
  addPhotoFormats: 'JPG و PNG و WEBP و GIF',
  fileTooLarge: 'يجب أن يكون حجم الملفات أقل من 10 ميجابايت',
  photo: 'صورة',
  photos: 'صور',
  submittingAs: 'يتم الإرسال باسم',
  submitting: 'جاري الإرسال...',

  searchPlaceholder: 'البحث في التذاكر...',
  filterByStatus: 'تصفية حسب الحالة',
  selectStatus: 'اختر الحالة',
  noTickets: 'لم يتم العثور على تذاكر دعم',

  tabOverview: 'نظرة عامة',
  tabNotes: 'الملاحظات',
  assignedTo: 'مسند إلى',
  unassigned: 'غير مسند',
  tenant: 'المستأجر',
  resolvedAt: 'تاريخ الحل',
  updateStatus: 'تحديث الحالة',

  noNotes: 'لا توجد ملاحظات بعد',
  addNote: 'إضافة ملاحظة',
  notePlaceholder: 'أضف ملاحظة...',

  createSuccess: 'تم إنشاء تذكرة الدعم بنجاح',
  updateSuccess: 'تم تحديث تذكرة الدعم بنجاح',
  createError: 'فشل في إنشاء تذكرة الدعم',
  updating: 'جارٍ التحديث...',
  customerSupportTitle: 'الدعم',
  customerSupportSubtitle: 'احصل على المساعدة بشأن طلباتك وتسليماتك وحسابك',
  myTickets: 'تذاكري',
  noMyTickets: 'ليس لديك أي تذاكر دعم حتى الآن',
}
